import { rankingData } from '@/mocks/home';

export default function Ranking() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-primary-500 text-background-50';
    if (rank === 3) return 'bg-secondary-500 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">吃瓜热榜</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">实时热度排行，看看今天大家都在吃什么瓜</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group border-b border-background-200/70 last:border-b-0"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm shrink-0 ${getRankStyle(item.rank)}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h4>
              </div>
              <div className="flex items-center gap-1 shrink-0">
                <i className={`${
                  item.change === 'up' ? 'ri-arrow-up-line text-primary-500' :
                  item.change === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                  'ri-more-line text-accent-500'
                } text-sm`}></i>
                <span className="text-sm font-semibold text-accent-600">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}